import * as React from 'react';
import * as styles from './AboutTab.css';
import { ArticleParagraph1 } from '@cian/ui-kit';

interface IAboutTabProps {
  firstColumnParagraphs?: string[];
  secondColumnParagraphs?: string[];
}

export function AboutTab({ firstColumnParagraphs, secondColumnParagraphs }: IAboutTabProps) {
  return (
    <div className={styles['tab']}>
      <div className={styles['tab__item']}>
        {React.Children.map(firstColumnParagraphs, paragraph => (
          <div className={styles['tab__description']}>
            <ArticleParagraph1>{paragraph}</ArticleParagraph1>
          </div>
        ))}
      </div>

      <div className={styles['tab__item']}>
        <div className={styles['tab__media']}>
          {React.Children.map(secondColumnParagraphs, paragraph => (
            <div className={styles['tab__description']}>
              <ArticleParagraph1>{paragraph}</ArticleParagraph1>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
